<template>
  <v-app id="app">
    <template v-if="loggedin">
        <Navbar v-if="loggedin" />
    </template>
    <router-view
      :key="$route.fullPath"
      :style="widthValue === 0 && mini  ? 'padding: 64px 0px 0px 80px;' : ''"
    />
    <template v-if="loggedin">
      <Footer />
    </template>
    <Snackbar :snackbar="snackbarStatus" :message="snackbarMessage"/>  
    <v-row justify="center" v-if="!currentUser.notice_read_status && loggedin">
      <v-dialog  v-model="legalnotice" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">{{ 'Copyright legal notice' | translate }}</v-card-title>
          <v-card-text>
            <p class="mb-2 text-subtitle-1">{{ (legalnoticedata!== undefined ? legalnoticedata.page_content : "") }}</p>
            <h3 class="mb-3">{{ 'Intellectual Property Rights' | translate }}</h3>
            <p class="text-subtitle-1">{{ 'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.' | translate }}</p>
            <v-checkbox v-model="acceptstatus" :label="'I accept this (required)' | translate"></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="acceptstatus ? 'green darken-1': 'grey darken-1' " text @click="(acceptstatus ? legalNoticeStatus(): '')">{{ 'Accept & Continue' | translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


  </v-app>
</template>

<script>
import Navbar from "./components/navbar/navbar.vue"
import Snackbar from "./components/snackbar/snackbar.vue"
import store from "@/store"
import axios from "axios"
import { mapGetters } from "vuex"
import { mapState } from "vuex"
import { UPDATE_USER, CHECK_AUTH } from "@/store/actions.type"
import { SET_LOADING } from "@/store/mutations.type"
export default {
  name: "App",
  components: {
    Navbar,
    Snackbar,
    Footer: () => import('@/components/footer/footer')
  },
  computed: {
    isAuthenticated: function() {
      return this.$store.getters.isAuthenticated;
    },
    legalnotice: function() {
      return (this.currentUser.notice_read_status === 0 && this.loggedin ? true : false)
    },
    legalnoticedata: function (){
      let data = this.pagesdata.find(o=> o.page_slug == 'legalnotice')
      return data
    },
    ...mapState({
      snackbarStatus: state => state.globals.snackbarStatus,
      snackbarMessage: state => state.globals.snackbarMessage,
    }),      
    ...mapGetters(["widthValue","currentUser",'loggedin', 'pagesdata'])
  }, 
  created() {
    axios.interceptors.request.use(
      function(config) {
        store.commit(SET_LOADING, true);
        return config;
      },
      function(error) {
        return Promise.reject(error);
      }
    );
  },
  data: function() {
    return {
      acceptstatus: false,
    }
  },
  methods:{
    async legalNoticeStatus () {
      await this.$store.dispatch(UPDATE_USER, {
            email: this.currentUser.email,
            name: this.currentUser.name,
            address: this.currentUser.address,
            phone_no: this.currentUser.phone_no,
            salutation: this.currentUser.salutation,
            user_id: this.currentUser.user_id,
            roles: this.currentUser.roles,
            notice_read_status: 1,
            _method: "put"
          })
          .then(async resp => {
            if (resp.success) {
             await this.$store.dispatch(CHECK_AUTH).then( async userresp =>{
              if(userresp !== undefined && userresp.hasOwnProperty('success') && userresp.success ==true){
                store.commit(SET_LOADING, false);
              }
             })
            }
          });
    }
  }
};
</script>
